// ButtonStyled.js
import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'

export const StackServiceItem = styled(Stack)(({ theme, isWithImg }) => ({
  padding: isWithImg ? '2rem 0rem 0rem 2rem' : '2rem',

  ...(isWithImg && {
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      height: '32rem',
      marginBottom: '6rem',
    },
  }),
}))

export const StackImage = styled(Stack)(({ theme, isWithImg }) => ({
  ...(isWithImg && {
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      bottom: '-71px',
      right: 0,
    },
  }),
}))
